"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToBoolean = exports.customElement = void 0;
const customElement = (tagName) => (constructor) => {
    if (!customElements.get(tagName)) {
        customElements.define(tagName, constructor);
    }
};
exports.customElement = customElement;
const stringToBoolean = (value) => {
    if (typeof value === 'boolean')
        return value;
    if (value.toUpperCase() === "TRUE")
        return true;
    return false;
};
const getSveltePropValue = (prop, $$) => {
    let propIndex = $$.props[prop];
    return $$.ctx[propIndex];
};
/**
* transformToBoolean
* @property { string[] } props
* This will turn props passed from array into boolean (e.g 'true' => true)
*/
const transformToBoolean = (props) => (constructor) => {
    let newObject = {};
    return class extends constructor {
        connectedCallback() {
            super.connectedCallback();
            props.forEach(prop => {
                newObject[prop] = stringToBoolean(getSveltePropValue(prop, this.$$));
            });
            this.$$set(newObject);
        }
    };
};
exports.transformToBoolean = transformToBoolean;
